import { ClassroomIconType } from '@shared/enums/classroom-icon-type';

export class ClassroomIcon {
  classroomIconType: ClassroomIconType;
  classroomIconPath: string;
}
